/**
 * Calendar day-grid hour range.
 *
 * The Day/Week calendar grids render one row per hour from the clinic's
 * configurable start hour (`clinic.calendarStartHour`) up to 23:00.
 * The start hour is chosen at signup (PreferencesStep) and editable later in
 * Settings → התאמה אישית. Missing / invalid values fall back to 05:00, which is
 * the historical hard-coded grid start — so existing clinics see no change.
 */

export const DEFAULT_CALENDAR_START_HOUR = 5;
export const CALENDAR_START_HOUR_MIN = 1;
export const CALENDAR_START_HOUR_MAX = 20;
/** Exclusive end — the last rendered row is 23:00. */
export const CALENDAR_END_HOUR = 24;

export const formatCalendarHour = (hour) => `${String(hour).padStart(2, "0")}:00`;

/** Dropdown options for the start-hour selects (01:00 … 20:00). */
export const CALENDAR_START_HOUR_OPTIONS = Array.from(
  { length: CALENDAR_START_HOUR_MAX - CALENDAR_START_HOUR_MIN + 1 },
  (_, i) => {
    const value = CALENDAR_START_HOUR_MIN + i;
    return { value, label: formatCalendarHour(value) };
  }
);

/**
 * Normalize any raw value (Firestore field, form state, undefined) to a valid
 * start hour. Anything outside [MIN, MAX] or non-integer → default.
 */
export const normalizeCalendarStartHour = (raw) => {
  const n = Number(raw);
  if (!Number.isInteger(n)) return DEFAULT_CALENDAR_START_HOUR;
  if (n < CALENDAR_START_HOUR_MIN || n > CALENDAR_START_HOUR_MAX) {
    return DEFAULT_CALENDAR_START_HOUR;
  }
  return n;
};

/** Start hour for a clinic profile (backward compatible — field may be absent). */
export const getClinicCalendarStartHour = (clinicProfile) =>
  normalizeCalendarStartHour(clinicProfile?.calendarStartHour);

/** Hour rows for the grid: [startHour, …, 23]. */
export const buildCalendarHours = (startHour) => {
  const start = normalizeCalendarStartHour(startHour);
  return Array.from({ length: CALENDAR_END_HOUR - start }, (_, i) => start + i);
};
